import __ from "standard/dunder";
import * as f from "standard/f";

function formData(_target, _propertyKey, descriptor) {
  const next = descriptor.value;

  Object.assign(descriptor, {
    value(event) {
      const elements = this.shadowRoot.querySelectorAll("*");
      const inputs = Array.from(elements).filter((element) =>
        f.equals(element.type, __.control__),
      );
      const valid = inputs.every((input) => input.validity.valid);

      if (valid) {
        return Reflect.apply(next, this, arguments);
      }

      inputs
        .find((input) => f.not(input.validity.valid))
        .dispatchEvent(new Event("invalid"));
    },
  });
}

export default formData;
